var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"padded-space",attrs:{"id":"plaid-integrations-view"}},[_c('div',{staticClass:"centered-space"},[_c('h2',[_vm._v("Plaid Integrations")]),_c('BoxGridBlock',{attrs:{"cols":"12"}},[_c(_setup.PlaidIntegrationsTestComponent)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }